import React from "react";
import { format } from 'date-fns';




const violationHeaderStyle = {
    float: 'left',
    fontWeight: 'bold'
};

const violationDateStyle = {
    float: 'right',
    fontSize: 'small'
};

export const LicensePlatePublicDetail = ({ LicensePlate }) => {
    if (!LicensePlate) return <div />;

    let hookedTime = '';
    if (LicensePlate.towJobHookedTimeAsString != '') {
        hookedTime = format(new Date(LicensePlate.towJobHookedTimeAsString), 'M/d/yy H:mm');
    }

    return (
        <tr>
            <td>
                <div style={violationHeaderStyle}>
                    Violation ID: {LicensePlate.violationID}
                </div>
                <div style={violationDateStyle}>
                    {format(new Date(LicensePlate.infractionCreatedTimeAsString), 'M/d/yy H:mm')}
                </div>
                <div style={{ clear: 'both' }} />
                <div>
                    <b>Violation:</b> {LicensePlate.violationDescription}
                </div>
                <div>
                    <b>Vehicle:</b> {LicensePlate.vehicleDescription}
                </div>
                <div>
                    <b>VIN:</b> {LicensePlate.vin}
                </div>
                <div>
                    <b>Tow company:</b>
                </div>
                <div>
                    &nbsp;&nbsp;&nbsp;{LicensePlate.companyName}
                </div>
                <div>
                    &nbsp;&nbsp;&nbsp;{LicensePlate.companyPhoneFormatted}
                </div>
                <div>
                    &nbsp;&nbsp;&nbsp;<a href={LicensePlate.companyWebsite} target={"_blank"}>{LicensePlate.companyWebsite}</a>
                </div>
                <div>
                    <b>Towed at:</b> {hookedTime}
                </div>
                <div>
                    <b>Lot:</b> {LicensePlate.towJobStorageLot}
                </div>
            </td>
        </tr>
    );
};
